import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Contact } from "../components/contact";
import OptimizedImage from "../components/OptimizedImage";

import electricalData from "../data/services/electricinstrument.json";
import JsonData from "./../data/data.json";
import { NavigationCommon } from "../components/navigationCommon";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import Projects from "../components/projects";

const ElectricalServicePage = () => {

  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  return (
    <div>
     {/* Navigation */}
        <Navigation />
 <Header data={electricalData.Header} />
      {/* Hero Banner */}
      <section
        className="service-hero"
        style={{
          backgroundImage: "url(/img/services/electrical-banner.jpg)"
        }}
      >
       
      </section>

      {/* Main Content */}
<section
  id="service-details"
  className="container"
  style={{
    paddingTop: "80px",
    paddingBottom: "0px"
  }}
>

  <div className="row">
    <div className="col-md-10 col-md-offset-1 service-content">
<div
  className="service-top-image"
  style={{
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto 40px",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.15)"
  }}
>
  <OptimizedImage
    src="/img/services/electrical-detail.jpg"
    alt="Electrical & Control Systems"
    width={900}
    height={420}
    placeholder={true}
  />
</div>



      <h2 className="service-title">
        Electrical, Instrumentation & Control Systems Contractor in Singapore
      </h2>

      <p className="service-intro">
        <strong>Aerolines Engineering & Construction Pte Ltd</strong> provides
        end-to-end electrical, instrumentation, and control system solutions for
        industrial and commercial facilities across Singapore. We specialise in
        <strong> PLC control systems</strong>, <strong>integrated testing systems</strong>,
        <strong> industrial wiring works</strong>, fabrication and troubleshooting of
        control systems, and preventive maintenance contracts, delivering
        reliable, safe, and efficient engineering solutions tailored to each
        client’s operational requirements.
      </p>

      <p className="service-highlight">
        All services are delivered under an
        <strong> ISO 9001:2015 certified Quality Management System</strong>.
      </p>

      <div className="service-section">
        <h3>PLC Control Systems</h3>
        <p>
          We design, program, and integrate <strong>PLC control systems</strong> to
          automate industrial processes, improve operational efficiency, and
          minimise downtime. Our PLC solutions are customised for manufacturing
          plants, process industries, and specialised industrial environments.
        </p>
      </div>

      <div className="service-section">
        <h3>Integrated Testing Systems</h3>
        <p>
          Our engineers design and fabricate custom
          <strong> integrated testing systems</strong>, including standalone test
          boxes and automatic test equipment, to validate functionality,
          performance, and safety.
        </p>
      </div>

      <div className="service-section">
        <h3>Industrial Wiring Works</h3>
        <p>
          We deliver professional <strong>industrial electrical wiring works</strong>,
          including installations, upgrades, troubleshooting, and optimisation,
          fully compliant with Singapore safety standards.
        </p>
      </div>

      <div className="service-section">
        <h3>Fabrication & Troubleshooting of Testing & Control Systems</h3>
        <p>
          We specialise in <strong>fabrication, repair, troubleshooting, and
          reverse engineering</strong> of testing and control systems to extend
          equipment life and reduce downtime.
        </p>
      </div>

      <div className="service-section">
        <h3>Industrial Preventive Maintenance Contracts</h3>
        <p>
          We provide <strong>preventive maintenance contracts</strong> to ensure
          uninterrupted operations, safety compliance, and long-term asset
          protection.
        </p>
      </div>

    </div>
  </div>
</section>
<About data={landingPageData.About} />
              <Services data={landingPageData.Services} />
              {/* <Gallery data={landingPageData.Gallery} /> */}
                 <Projects />

      {/* Contact */}
           <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default ElectricalServicePage;
